import { getLocalStorageData } from "../../utils/LocalStorageService";
import "./home.scss"
import { DatePicker } from "antd";
import kalkiUniverse from "../../assets/kalki/kalkiUniverse.jpg";

const { RangePicker } = DatePicker;

type Props = {};

const Home = (props: Props) => {

    return (
        // <div
        //     className="home-banner d-flex align-items-center justify-content-center text-center p-0"
        //     style={{
        //         backgroundImage: `url(${kalkiUniverse})`,
        //     }}
        // >
        //     <div className="text-white px-3">
        //         <h1 className="fw-bold" style={{fontWeight: 900}}>Awaken the Divine Within</h1>
        //         <p className="fw-bold fs-4 mt-3" style={{fontWeight: 900}}>
        //             Where Spiritual Wisdom, Karma-Dharma, and Advanced AI unite for global transformation.
        //         </p>
        //     </div>
        // </div>
        <div className="position-relative w-100 vh-100 overflow-hidden text-center text-white d-flex justify-content-center align-items-center">
            {/* Background image */}
            <div
                className="position-absolute top-0 start-0 w-100 h-100 bg-dark"
                style={{
                    backgroundImage: `url(${kalkiUniverse})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    zIndex: 0,
                    transform: "scaleX(-1)", // Optional mirror effect
                }}
            ></div>

            {/* Foreground text */}
            <div className="position-relative z-1 px-3">
                <h1 className="fw-bold">Awaken the Divine Within</h1>
                <p className="fw-bold fs-4 mt-3">
                    Where Spiritual Wisdom, Karma-Dharma, and Advanced AI unite for global transformation.
                </p>
            </div>
        </div>
    );
};

export default Home;